import { render, staticRenderFns } from "./CourseSeoFields.vue?vue&type=template&id=0ec246c5&scoped=true&"
import script from "./CourseSeoFields.vue?vue&type=script&lang=js&"
export * from "./CourseSeoFields.vue?vue&type=script&lang=js&"
import style0 from "./CourseSeoFields.vue?vue&type=style&index=0&id=0ec246c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec246c5",
  null
  
)

export default component.exports